var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallWhiteLogoAcium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 68.459,
    viewBox: "0 0 69 68.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1217",
    "data-name": "Caminho 1217",
    d: "M127.071,648.787l13.69-2.858,20.724-41.161,20.866,41.018,13.72,3-34.5-68.459Z",
    transform: "translate(-127.071 -580.328)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteLogoAcium);
export default __webpack_public_path__ + "static/media/smallWhiteLogoAcium.56de22d5bace7ffcdc553f104ddec2ed.svg";
export { ForwardRef as ReactComponent };